import React from 'react';

const applyStylesRecursively = (children, propsMap) => React.Children.map(children, (child) => {
	if (!React.isValidElement(child)) return child;

	const props = child.type === 'h2' ? propsMap.h2 : propsMap.default;

	// Recursively style children of this child
	const newChildren = applyStylesRecursively(child.props.children, propsMap);

	return React.cloneElement(child, { ...props, children: newChildren });
});

export default function ApplyStyleWrapper({ children, styles }) {
	const styledChildren = applyStylesRecursively(children, styles);
	return <div>{styledChildren}</div>;
}
